import React, { Fragment, useEffect, useMemo, useState } from 'react';
import "./messengers.css";
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesPacking, faDownLong } from '@fortawesome/free-solid-svg-icons';
import selectedPhoto from "./../../Images/selected_Photo.png"
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveToken, getId, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { toast } from 'react-toastify';
import { getALlMessengers, getMessengersIDsAPI } from '../../RTK/Slice/Messengers/MessengersSlice';
import { useParams } from 'react-router-dom';
import { STATUS } from '../../Constants';
import { useDebounce } from 'use-debounce';
import { motion } from 'motion/react';



const AllMessengersPage = () => {

    // For Check Focus Of Input
    const [inputFocus , setInputFocus] = useState(false);

    // For Access Search Input
    const [searchInput , setSearchInput] = useState("") ; 
    // For Delay action for input change (Save Performance)
    const [value] = useDebounce(searchInput, 1000);

    // For Store Selected Users 
    const [selectedUsers , setSelectedUsers] = useState([]) ; 

    // For Select All Users
    const [selectAllChat , setSelectAllChat] = useState(false) ; 

    // For Fire Action 
    const dispatch = useDispatch() ;
    
    // For Get Token
    const token  = useSelector(getToken) ; 


    // For Get User Token
    const userToken = useSelector(getActiveToken) ;

    // For Get Page ID
    const {pageId} = useParams();

    // For Get User ID
    const userId = useSelector(getId);

    // For Access Data and Status of Reqeust
    const {users, status } = useSelector(getALlMessengers) ;


    // For Get Messengers Data 
    useMemo(()=>{
        if(userToken){
            dispatch(getMessengersIDsAPI({token , userToken , pageId , userId }))
        }else{
            toast.info("Please Choose Token")
        }
    } , [pageId]) ;

    // For Select User 
    const selectUserHandler = (e)=>{
        let isSelected = e.target.checked ;
        let ID = e.target.value ; 
        if(isSelected){
            if(!selectedUsers.includes(ID))
                setSelectedUsers([...selectedUsers , ID]) ;
        }else{
            setSelectedUsers(prev =>selectedUsers.filter((id)=>id !== ID))
        }
    }

    // For Select All Uses
    const selectAllUsersHandler = (e)=>{

     const isSelected = e.target.checked ; 
    if(isSelected){
        setSelectAllChat(true) ;
        setSelectedUsers(
            users
            ?.filter((item)=>  item.name === '' || item.name?.toLowerCase().includes(value.toLowerCase()))
            ?.map((item)=>item.id)
            )
            
    }
    else{
        setSelectAllChat(false);
        setSelectedUsers([]);
    }
    }

  return (
    <div className='messenger-page'>
        <div className='tools-bar'>
            <form className='search-tools'>
                <div className={`search-bar ${inputFocus ? 'search-bar-active' : ''} `}>
                    <svg xmlns="http://www.w3.org/2000/svg" className='lucide lucide-search-icon lucide-search magnify' width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>
                    <input onChange={(e)=>setSearchInput(e.target.value)} onFocus={()=>setInputFocus(true)} onBlur={()=>setInputFocus(false)} autoFocus placeholder='Search for client'/>
                </div>
                
                    <CSVLink
                        data={users} 
                        filename="Messengers.csv"
                    >
                        <button className='save-btn' title='Download Data'>
                            <FontAwesomeIcon icon={faDownLong} />
                        </button>
                    </CSVLink>
                
                
                    {users.length > 0 && status === STATUS.SUCCESS  ?
                    (
                        <div className='selected-ids'>
                            <img src={selectedPhoto} alt='selected' />
                            <p className='text-selected-color'>Extracted {users.length}</p>
                        </div>
                    ) :""}
                    
            </form>
            <div className='extract-data-tools'> <button className="extract-btn">Extract Data {selectedUsers.length > 0 ?`(${selectedUsers.length})` : ""} <FontAwesomeIcon icon={faBoxesPacking} /></button></div>
        </div>
        <div className='table'>

            <div className='table-header'>
                <div className='col'>
                    <input type="checkbox" checked={selectAllChat} onChange={selectAllUsersHandler} />
                </div>
                <div className='col'>
                    ID
                </div>
                <div className='col'>
                    Name
                </div>
                <div className='col'>
                    Gender
                </div>
            </div>

            <div className='table-body'>
                {
                        status === STATUS.SUCCESS ?
                        users
                        ?.filter((item)=>  item.name === '' || item.name?.toLowerCase().includes(value.toLowerCase()))
                        .map((user  ,idx)=>{
                            return (
                                <motion.div className='table-row' key={idx}
                                initial={
                                {opacity :0
                                }
                                }

                                whileInView={
                                {opacity :1

                                }}
                                >
                                    <div className='col'>
                                        <input type="checkbox" value={user.id} checked={selectedUsers.includes(user.id)} onChange={selectUserHandler} />
                                    </div>
                                    <div className='col'>{user.id}</div>
                                    <div className='col'>{user.name}</div>
                                    <div className='col'>{user.gender.toLowerCase()}</div>
                                </motion.div>
                            )
                        }) :""
                }

                {
                    status === STATUS.LOADDING ? 
                    (
                    <Fragment>
                        <div className='table-row table-row-loading'>
                            <div className='col'>
                                <Skeleton variant="rectangular" width={140} height={22} style={{borderRadius :"5px"}} />
                            </div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                        </div>
                        <div className='table-row table-row-loading'>
                            <div className='col'>
                                <Skeleton variant="rectangular" width={140} height={22} style={{borderRadius :"5px"}} />
                            </div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={140} height={22} /></div>
                        </div>
                        <div className='table-row table-row-loading'>
                            <div className='col'>
                                <Skeleton variant="rectangular" width={140} height={22} style={{borderRadius :"5px"}} />
                            </div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={160} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={160} height={22} /></div>
                            <div className='col'><Skeleton variant="rectangular" style={{borderRadius :"5px"}} width={160} height={22} /></div>
                        </div>
                    </Fragment>
                
                    ) :""
                }
                
            </div>
            {users.length === 0 && status !== STATUS.LOADDING ? (<h2 style={{textAlign :"center" , padding:"15px 0px"}}>No Messengers</h2>) :""}
            
        </div>
    </div>
  )
}

export default AllMessengersPage
